import React from "react";
import ColaboradoresApiClient from "../../api/colaboradores";
import useApi from "../useApi";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";
import { AppContext } from "../../contexts/AppContext";
import OptionsSwal from "../../components/Swal/optionsSwal";
import CommonSwal from "../../components/Swal/commonSwal";
import { hoje } from "../../helpers/mesesHelper";

export default function useDadosPessoais(uid) {
  const [municipioAtivo, setMunicipioAtivo] = React.useState("");
  const [dependentes, setDependentes] = React.useState([]);
  const [dadosPessoaisValues, setDadosPessoaisValues] = React.useState({});
  const [dadosPessoaisOriginalValues, setDadosPessoaisOriginalValues] =
    React.useState({});
  const { session } = React.useContext(AppContext);

  const { request: getDadosPessoais, data: dadosPessoaisResponse } = useApi(
    ColaboradoresApiClient.getDadosPessoais
  );
  const { request: getDependentes, data: dependentesResponse } = useApi(
    ColaboradoresApiClient.getDependentes
  );
  const putDadosPessoaisApi = useApi(ColaboradoresApiClient.putDadosPessoais);
  const postDependentesApi = useApi(ColaboradoresApiClient.postDependentes);
  const deleteDependentesApi = useApi(ColaboradoresApiClient.deleteDependentes);

  //Busca dados do colaborador ao renderizar tela
  React.useEffect(() => {
    if (!uid || !session?.empresa) return;
    getDadosPessoais(session.empresa.replace(/E/gi, ""), uid);
  }, [getDadosPessoais, session.empresa, uid]);

  //Busca dependentes ao renderizar tela
  React.useEffect(() => {
    if (!uid || !session?.empresa) return;
    getDependentes(session.empresa.replace(/E/gi, ""), uid);
  }, [getDependentes, session.empresa, uid]);

  //Define estado ao receber dados do colaborador
  React.useEffect(() => {
    if (!dadosPessoaisResponse) return;
    setDadosPessoaisValues((prevValues) => ({
      ...prevValues,
      ...dadosPessoaisResponse,
      dependentes: dadosPessoaisResponse?.dependentes === "true",
    }));
    setDadosPessoaisOriginalValues((prevValues) => ({
      ...prevValues,
      ...dadosPessoaisResponse,
      dependentes: dadosPessoaisResponse?.dependentes === "true",
    }));
    setMunicipioAtivo(dadosPessoaisResponse?.cidade_nascimento);
  }, [dadosPessoaisResponse, setDadosPessoaisValues]);

  //Define estado ao receber dependentes
  React.useEffect(() => {
    if (!dependentesResponse) return;
    setDependentes(() => [...dependentesResponse]);
  }, [dependentesResponse]);

  const salvaDadosPessoais = (rascunho = false) => {
    return new Promise((resolve, reject) => {
      const formData = new FormData();
      formData.append("uid_colaborador", uid);
      formData.append("nome", dadosPessoaisValues?.nome);
      formData.append("cpf", dadosPessoaisValues?.cpf);

      if (rascunho) {
        if (Validation.validaCpf(dadosPessoaisValues?.cpf))
          return reject(
            ErrorSwal({
              text: "CPF inválido!",
            })
          );

        if (!dadosPessoaisValues?.nome)
          return reject(
            ErrorSwal({
              text: "Nome do colaborador obrigatório!",
            })
          );
      }

      formData.append("pis", dadosPessoaisValues?.pis || "");
      formData.append(
        "data_nascimento",
        dadosPessoaisValues?.data_nascimento || ""
      );
      formData.append("sexo", dadosPessoaisValues?.sexo || "");
      formData.append("deficiencia", dadosPessoaisValues?.deficiencia || "");
      formData.append("estado_civil", dadosPessoaisValues?.estado_civil || "");
      formData.append("raca_cor", dadosPessoaisValues?.raca_cor || "");
      formData.append(
        "grau_instrucao",
        dadosPessoaisValues?.grau_instrucao || ""
      );
      formData.append("cep", dadosPessoaisValues?.cep || "");
      formData.append("rua", dadosPessoaisValues?.rua || "");
      formData.append("numero", dadosPessoaisValues?.numero || "");
      formData.append("bairro", dadosPessoaisValues?.bairro || "");
      formData.append("cidade", dadosPessoaisValues?.cidade || "");
      formData.append("uf", dadosPessoaisValues?.uf || "");
      formData.append(
        "uf_nascimento",
        dadosPessoaisValues?.uf_nascimento || ""
      );
      if (dadosPessoaisValues?.uf_nascimento !== "EX")
        formData.append(
          "cidade_nascimento",
          dadosPessoaisValues?.cidade_nascimento || ""
        );
      formData.append("email", dadosPessoaisValues?.email || "");
      formData.append("celular", dadosPessoaisValues?.celular || "");
      formData.append(
        "nacionalidade",
        dadosPessoaisValues?.nacionalidade || ""
      );
      formData.append("dependentes", dadosPessoaisValues?.dependentes);
      dadosPessoaisValues?.nacionalidade === "2" &&
        formData.append(
          "informe_nacionalidade",
          dadosPessoaisValues?.informe_nacionalidade || ""
        );

      if (!rascunho) {
        if (Validation.verificarForm(formData))
          return reject(
            ErrorSwal({
              text: "Favor preencher todos os dados obrigatórios.",
            })
          );

        const newDataNascimento = new Date(
          dadosPessoaisValues?.data_nascimento
        );
        if (newDataNascimento > hoje)
          return reject(
            ErrorSwal({
              text: "Data de nascimento inválida.",
            })
          );

        if (Validation.validarEmail(dadosPessoaisValues?.email))
          return reject(
            ErrorSwal({
              text: "Favor informar um e-mail válido.",
            })
          );
      }

      if (dadosPessoaisValues?.uf_nascimento === "EX")
        formData.append(
          "cidade_nascimento",
          dadosPessoaisValues?.cidade_nascimento || ""
        );
      dadosPessoaisValues?.nacionalidade !== "2" &&
        formData.append(
          "informe_nacionalidade",
          dadosPessoaisValues?.informe_nacionalidade || ""
        );
      formData.append("identidade", dadosPessoaisValues?.identidade || "");
      formData.append(
        "orgao_expeditor",
        dadosPessoaisValues?.orgao_expeditor || ""
      );
      formData.append("complemento", dadosPessoaisValues?.complemento || "");

      putDadosPessoaisApi
        .request(session.empresa.replace(/E/gi, ""), uid, formData)
        .then((response) => {
          if (!response) return;

          resolve();
        });
    });
  };

  const novoDependente = async () => {
    const formData = new FormData();
    formData.append("dependente_nome", dadosPessoaisValues?.nome_dependente);
    formData.append("dependente_cpf", dadosPessoaisValues?.cpf_dependente);
    formData.append(
      "dependente_nascimento",
      dadosPessoaisValues?.data_nascimento_dependente
    );
    formData.append("dependente_tipo", dadosPessoaisValues?.tipo_dependente);
    formData.append("uid_colaborador", uid);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const newDataNascimento = new Date(
      dadosPessoaisValues?.data_nascimento_dependente
    );
    if (newDataNascimento > hoje)
      return ErrorSwal({
        text: "Data de nascimento inválida.",
      });

    const response = await postDependentesApi.request(
      session.empresa.replace(/E/gi, ""),
      uid,
      formData
    );
    if (!response) return;
    setDadosPessoaisValues((prevValues) => ({
      ...prevValues,
      nome_dependente: "",
      cpf_dependente: "",
      data_nascimento_dependente: "",
      tipo_dependente: "",
    }));
    CommonSwal({
      icon: "success",
      title: "Dependente incluído com sucesso.",
    });
    getDependentes(session.empresa.replace(/E/gi, ""), uid);
  };

  const excluirDependente = React.useCallback(
    async (uid_dependente) => {
      OptionsSwal({
        text: "Você deseja realmente excluir o dependente?",
        icon: "question",
      }).then(async (result) => {
        if (result.isConfirmed) {
          const response = await deleteDependentesApi.request(
            session.empresa.replace(/E/gi, ""),
            uid,
            uid_dependente
          );
          if (!response) return;
          getDependentes(session.empresa.replace(/E/gi, ""), uid);
        }
      });
    },
    [deleteDependentesApi, getDependentes, session.empresa, uid]
  );

  return {
    dependentes,
    salvaDadosPessoais,
    municipioAtivo,
    dadosPessoaisValues,
    setDadosPessoaisValues,
    novoDependente,
    excluirDependente,
    dadosPessoaisOriginalValues,
    setDadosPessoaisOriginalValues,
  };
}
